import { render } from "./LbrxBookingSuccessPopup.vue?vue&type=template&id=6a358714&scoped=true"
import script from "./LbrxBookingSuccessPopup.vue?vue&type=script&lang=js"
export * from "./LbrxBookingSuccessPopup.vue?vue&type=script&lang=js"

import "./LbrxBookingSuccessPopup.vue?vue&type=style&index=0&id=6a358714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a358714"]])

export default __exports__